export const LOCATION_CHANGE_EVENT = 'amt:locationchange';
export const BEFORE_NAVIGATE_EVENT = 'amt:before-navigate';

let installed = false;

/**
 * pushState / replaceState 不会触发 popstate。管理端同时有 Vue 外壳与 React
 * Router，程序内跳转后需要一个共同的地址变更信号，否则正文已经进入新页面，
 * 顶栏与侧栏仍停在旧路由。
 */
export function installLocationChangeEvents(): void {
  if (installed) return;
  installed = true;

  const originalPushState = window.history.pushState.bind(window.history);
  const originalReplaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = (data, unused, url) => {
    originalPushState(data, unused, url);
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
  };
  window.history.replaceState = (data, unused, url) => {
    originalReplaceState(data, unused, url);
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
  };
}

/**
 * Vue 列表 → React 详情等跨壳跳转：走 history API，让顶栏/侧栏立刻跟地址同步，
 * 并避免整页刷新。React 表面重挂时会再按当前地址 load，消除「还在报价」首帧错觉。
 */
export function navigateApp(url: string): void {
  const next = new URL(url, window.location.origin);
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const target = `${next.pathname}${next.search}${next.hash}`;
  if (target === current) return;
  if (
    !window.dispatchEvent(
      new CustomEvent(BEFORE_NAVIGATE_EVENT, { cancelable: true, detail: { url: target } })
    )
  )
    return;
  window.history.pushState({}, '', target);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
